import { useState } from "react";
import { AnimateOnScroll } from "../../../components/animate";
import { AnimateWordsOnScroll } from "../../../components/animate/animateWords";
import { ScribbleReveal } from "../../../components/animate/scribbleReveal";
import { BlogCard, BlogCardLoader } from "../../../components/blog/blogCard";
import { EmptyState } from "../../../components/empty";
import { TabNav } from "../../../components/tabNav";
import {
  useGetBlogCategoriesQuery,
  useGetBlogPostsQuery,
} from "../../../redux/features/blog/blog.api";
import { scribblePaths } from "../data/landingContent";

const ALL_CATEGORY_SLUG = "all";

export const BlogPage = () => {
  const [activeSlug, setActiveSlug] = useState(ALL_CATEGORY_SLUG);

  const { data: posts, isLoading: postsLoading } = useGetBlogPostsQuery();
  const { data: categories, isLoading: categoriesLoading } =
    useGetBlogCategoriesQuery();

  const filteredPosts =
    activeSlug === ALL_CATEGORY_SLUG
      ? posts
      : posts?.filter((post) => post.category?.slug === activeSlug);

  const isLoading = postsLoading || categoriesLoading;

  return (
    <div className="max-width-website flex flex-col items-center gap-11 pb-20 pt-12 md:pt-20">
      <div className="flex w-full flex-col items-center gap-4 text-center">
        <div className="relative z-[1] inline-block">
          <ScribbleReveal
            {...scribblePaths.hero}
            className="pointer-events-none absolute left-1/2 top-[58%] -z-10 w-[170px] -translate-x-1/2 -translate-y-1/2 md:w-[260px]"
          />
          <AnimateWordsOnScroll
            as="p"
            className="relative text-[32px] font-dela not-italic leading-[38px] tracking-[-0.64px] text-ink md:text-[48px] md:leading-[50px] md:tracking-[-0.96px]"
          >
            Blog
          </AnimateWordsOnScroll>
        </div>
        <AnimateOnScroll animation="blur-up" delay={0.3}>
          <p className="font-onest text-[20px] font-normal leading-[28px] tracking-[-0.4px] text-ink">
            Updates and announcements from Tikket.
          </p>
        </AnimateOnScroll>
      </div>

      {!categoriesLoading && categories?.length ? (
        <TabNav
          navs={[
            { title: "All", to: ALL_CATEGORY_SLUG },
            ...categories.map((category) => ({
              title: category.title,
              to: category.slug,
            })),
          ].map((tab) => ({
            ...tab,
            onClick: () => setActiveSlug(tab.to),
          }))}
          activeTab={activeSlug}
          variant="switcher"
          className="w-fit !rounded-full !border-[5px] !border-grey-100 !bg-grey-100 !p-0 !shadow-none"
          tabClassName="!rounded-full !px-6 !py-2 !font-onest !text-[16px] !font-medium !text-[#50597d]"
        />
      ) : undefined}

      <div className="flex w-full max-w-[1080px] flex-col gap-14 md:gap-[72px]">
        {isLoading ? (
          Array.from({ length: 3 }).map((_, idx) => (
            <BlogCardLoader key={idx} />
          ))
        ) : filteredPosts?.length ? (
          filteredPosts.map((post) => <BlogCard key={post._id} post={post} />)
        ) : (
          <EmptyState
            text="No posts yet"
            subtext="Check back soon for updates and announcements from Tikket."
          />
        )}
      </div>
    </div>
  );
};
